import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../layouts/layout"
import SEO from "../components/seo"

import { Modules } from "../components/modules"
import { ModulesPageQuery } from "../../types/graphql-types"

export interface ModulesPageData {
  data: ModulesPageQuery
}

const ModulesPage: React.FC<ModulesPageData> = ({ data }) => {
  const stpos = data.allStposYaml.nodes
  const modules = data.allModulesYaml.nodes

  return (
    <Layout className="" containerClass="md:max-w-6xl">
      <SEO title="Lehrveranstaltungen" />
      <div class="mb-10">
        <h1 class="text-2xl sm:text-4xl inline-block mr-4">Module</h1>
        <div class="inline-block text-umr-grey-600">
          mit informatik-fachdiaktischem Anteil
        </div>
      </div>
      <Modules modules={modules} stpos={stpos} />
    </Layout>
  )
}

export default ModulesPage

export const modulesPageQuery = graphql`
  query ModulesPage {
    allModulesYaml {
      nodes {
        ...Modules
      }
    }

    allStposYaml {
      nodes {
        ...StPOs
      }
    }
  }
`
